import { render, staticRenderFns } from "./MiniKaskoCustomerForm.vue?vue&type=template&id=cbce8934&scoped=true&"
import script from "./MiniKaskoCustomerForm.vue?vue&type=script&lang=js&"
export * from "./MiniKaskoCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./MiniKaskoCustomerForm.vue?vue&type=style&index=0&id=cbce8934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce8934",
  null
  
)

export default component.exports